import { Controller } from '@hotwired/stimulus';
import { mountVueApp } from 'shared/vue/mountVueApp';
import { getPreviewUrl } from 'manage/utils/getPreviewUrl';

export default class extends Controller {
  static targets = ['custom', 'template'];
  static values = { data: Object };

  connect() {
    const el = this.templateTarget;
    const { icon, header } = this.dataValue;
    const customs = {};

    for (const custom of this.customTargets) {
      customs[custom.dataset.id] = custom.dataset.image || '';
    }

    this.vueApp = mountVueApp(el, {
      data: {
        icon,
        header,
        customs,
      },
      methods: {
        onChangeIcon(e) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.icon = url;
          });
        },
        onChangeHeader(e) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.header = url;
          });
        },
        onChangeCustom(e, id) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.customs = Object.assign({}, this.customs, { [id]: url });
          });
        },
      },
    });
  }

  disconnect() {
    this.vueApp?.unmount();
  }
}
